import { Controller } from "@hotwired/stimulus"

// job_change_intention.html.erb の「転職意向」 button (4 択) 用 controller (#1833 PR 8b)。
//
// 旧 inline JS は button の `onclick="selectJobIntention('value')"` で global function を呼ぶ
// pattern (script tag inline)。動的に <form> を生成して CSRF / _method / 意向値の hidden input
// を append、document.body に attach して submit する 動的 form 生成 pattern。
//
// 加えて旧 init 関数は localStorage 経由 (`job_change_intention` key) で前回値を読んで clear
// する後始末を行う。これは別 device で resume / browser-back 時の stale state 防止が目的。
//
// scope: intention button group の wrapper div に置く。
//
// XSS 安全性: form.action / hidden value は server 提供 (auth_registration_path / @intentions
// の :value) で、controller 側で literal string として扱う。input.value 設定は textContent 同等
// (DOM API、innerHTML 不使用)。
//
// Rule of Three: 1 view 1 instance (job_change_intention 専用)、actionUrl を value 渡しで形だけ
// generic にしているが他 step に展開予定なし。CSRF / _method / field name は hardcoded で OK。
export default class extends Controller {
  static values = { actionUrl: String }

  // 別 device / browser-back 等で前回保存された stale な intention を clear。
  // localStorage.removeItem は key 不在でも no-op (idempotent) のため `if (getItem)` の
  // gate 無しで直接呼ぶ (#1858 review Minor: コメントと gate の矛盾を解消)。
  connect() {
    localStorage.removeItem("job_change_intention")
  }

  // intention button click: 動的 <form> を生成して submit。
  // - method: POST + _method: patch (Rails の PATCH 経路)
  // - CSRF token: meta tag から読取り
  // - intention value: button の data-intention-value から取得
  submitIntention(event) {
    const value = event.currentTarget.dataset.intentionValue
    if (!value) return

    const form = document.createElement("form")
    form.method = "POST"
    form.action = this.actionUrlValue

    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    if (csrf) {
      this.#appendHidden(form, "authenticity_token", csrf)
    }
    this.#appendHidden(form, "_method", "patch")
    this.#appendHidden(form, "job_change_intention", value)

    document.body.appendChild(form)
    form.submit()
  }

  #appendHidden(form, name, value) {
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = name
    input.value = value
    form.appendChild(input)
  }
}
